import React from 'react'
import { FormattedMessage } from 'react-intl'

const ValueOrElse = (props: { children?: any; orElse?: React.ReactNode }) =>
  props.children || props.orElse || <FormattedMessage id="common.NA" />

export default ValueOrElse
